import { REPORTS_ACTION_TYPES } from '../../actions/reports/reports_action';

const initialState = {
    collection: []
};

export const yearlyReports = (state = initialState, action) => {
    switch (action.type) {
        case REPORTS_ACTION_TYPES.GET_YEARLY_REPORTS_SUCCESS:
            return { ...state, collection: action.payload };
        case REPORTS_ACTION_TYPES.GET_YEARLY_REPORTS_VALUES:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
